import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as moment from 'moment/moment';
import { ApiServiceService } from '../api-service.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Keys, StorageService } from '../service/storage.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LenderDashboardLinkProvider } from '../utils/lenderDashboardLinkProvider';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../service/finzy-flex/account/account.service';
@Component({
    selector: 'app-lenderconsent',
    templateUrl: './lenderconsent.component.html',
    styleUrls: ['./lenderconsent.component.css'],
    providers: [ApiServiceService]
})
export class LenderconsentComponent implements OnInit, AfterViewInit {

    result: any = [];
    portfolio_list: any = [];
    checkDisabled: boolean;
    consent_list: any = [];
    sign_documents: any = [];
    noConsent = false;
    dashLink: string;
    public consent_array: any = [];
    public loan_ids: any = [];
    displayedColumns: any = ['generated_loan_id', 'portfolio_name', 'disbursal_date', 'sign_documents'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    dataSource: any;
    isMobileApp: boolean = false;

    @ViewChild('linksdiv') linksWrapper;
    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService, private storageService: StorageService,
        private lenderDashboardLinkProvider: LenderDashboardLinkProvider, private accountService: AccountService) {
    }
    ngAfterViewInit() {
        let webkit = (window as any).webkit;
        if (webkit) {
            this.isMobileApp = true;
        }
    }
    public downloadFile(fileUrl: string) {
        //download from mobile app
        let message = {
            action: "download_file",
            url: fileUrl
        }
        let webkit = (window as any).webkit;
        if (webkit) {
            webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));
        } else {
            (<any>window).location.href = fileUrl;
        }
    }
    ngOnInit() {
        this.http.post<any>(this.ref.baseURL() + 'getAllContracts', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            token: this.storageService.getItem(Keys.TOKEN)
        }).subscribe((result) => {
            this.portfolio_list = result;
            for (let i = 0; i < this.portfolio_list.length; i++) {
                const loan_list = this.portfolio_list[i].loan_details;

                for (let j = 0; j < loan_list.length; j++) {

                    if (loan_list[j].loan_id != null) {
                        loan_list[j].portfolio_name = this.portfolio_list[i].portfolio_name;
                        const sign_doc = loan_list[j].loan_id.signed_document;
                        const disbursal_date = moment(loan_list[j].loan_id.loan_disbursed_on).format('D MMM YYYY ');
                        if (sign_doc.length != 0) {
                            for (let k = 0; k < sign_doc.length; k++) {
                                if (sign_doc[k].type == 'contract') {
                                    loan_list[j].sign_documents = sign_doc[k].source;
                                    loan_list[j].disbursal_date = disbursal_date;

                                }
                            }
                            const lender_id = this.storageService.getItem(Keys.LENDER_ID);
                            const lenders_invested = loan_list[j].loan_id.lenders_invested;
                            for (let m = 0; m < lenders_invested.length; m++) {
                                if (String(lender_id) == String(lenders_invested[m].lender_id) && lenders_invested[m].contract_consent_status == 'consent_pending') {
                                    loan_list[j].contract_consent_status = 'consent_pending';
                                    this.consent_list.push(loan_list[j]);

                                }
                            }

                            this.dataSource = new MatTableDataSource(this.consent_list);
                            this.dataSource.sort = this.sort;
                            this.dataSource.paginator = this.paginator;

                        } else {
                            this.noConsent = true;
                        }

                    }
                }
            }
        });

        this.lenderDashboardLinkProvider.getDashboardLink().then(link => {
            this.dashLink = link;
        });
    }

    getSignedConsents(obj, checked) {
        const loan_id = obj.loan_id._id;

        if (checked) {
            //this.consent_array.push(obj);
            this.consent_array.push({ 'loan_id': loan_id });

        } else {
            const index = this.consent_array.map(function (o) {
                return o.loan_id;
            }).indexOf(loan_id);
            this.consent_array.splice(index, 1);

        }
    }

    approveContract() {
        if (this.consent_array.length > 0) {
            this.http.post<any>(this.ref.baseURL() + 'signConsent', {
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                loan_ids: this.consent_array,
                token: this.storageService.getItem(Keys.TOKEN)
            }).subscribe((result) => {
                if (result.status_code == 200) {
                    this.consent_list.length = 0;
                    this.consent_array.length = 0;
                    this.ngOnInit();
                }
            });
        }
    }

    addLoan(i, event) {
    }

    public async downloadContractDoc(fileUrl: string) {
        try {
            const fileName = fileUrl.slice(fileUrl.lastIndexOf('/')+1); 
            this.accountService.getFileByName(fileName)
                .then((res) => {
                    let downloadUrl = URL.createObjectURL(res);
                    let downloadElem = document.createElement('a');
                    downloadElem.href = downloadUrl;
                    downloadElem.download = `${fileName}`;
                    downloadElem.click();
                })
                .catch((err) => {
                    console.log(err)
                })
        } catch(e) {
            console.log(e)
        }
    }

}
